/* unplugin-vue-components disabled */import { render } from "./PageNotFound.vue?vue&type=template&id=0880292d&scoped=true"
import script from "./PageNotFound.vue?vue&type=script&lang=js"
export * from "./PageNotFound.vue?vue&type=script&lang=js"

import "./PageNotFound.vue?vue&type=style&index=0&id=0880292d&scoped=true&lang=css"

import exportComponent from "E:\\Jweb\\结课作业\\KilaKila-Blog\\kilakila-frontend\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0880292d"]])

export default __exports__